module.exports = __webpack_public_path__ + "img/book-256.1e708293.png";